import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').CtaList}
 */
const CtaList = ({
    label,
    modulePaddingClasses = '',
    rows
}) => {
    return (
        <section className='module-cta-list'>
            <div className={`layout-container bg-neutral-00 ${modulePaddingClasses}`}>
                <div className='layout-grid flex-col sm:flex-row gap-y-38 sm:gap-y-0'>
                    <div className='w-full sm:w-4/12 md:w-3/12 layout-grid-col'>
                        {label && (
                            <h2 className='type-style-heading'>
                                {label}
                            </h2>
                        )}
                    </div>

                    {rows?.length > 0 && (
                        <div className='w-full sm:w-8/12 md:w-9/12'>
                            <ul className='flex flex-col gap-y-16'>
                                {rows.map((row, idx) => {
                                    const href = formatLinkBlockToUrl(row.link);

                                    return (
                                        <li
                                            className='flex flex-wrap'
                                            key={row.id}>
                                            <span className='w-4/12 sm:w-2/8 md:w-2/9 layout-grid-col type-style-heading'>
                                                {href ? (
                                                    <a
                                                        className='underline'
                                                        href={href}>
                                                        {row.label}
                                                    </a>
                                                ) : (
                                                    row.label
                                                )}
                                            </span>

                                            {row.description && (
                                                <span className='w-8/12 sm:w-6/8 md:w-7/9 layout-grid-col type-style-heading'>
                                                    {row.description}
                                                </span>
                                            )}

                                            {(idx !== rows.length - 1) && (
                                                <div className='w-full layout-grid-col'>
                                                    <div className='border-b border-neutral-400 pb-16' />
                                                </div>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default CtaList;
